import React, { lazy, Suspense } from "react";
import { SubHeading } from "../Components";

const SettlementListBody = lazy(() => import("./SettlementListBody"));

const SettlementList = () => {
  return (
    <>
      <SubHeading subTitle="Settlement List" />

      <Suspense fallback={<>Loading</>}>
        <SettlementListBody />
      </Suspense>
    </>
  );
};

export default SettlementList;
